import React, { PureComponent } from 'react';
import { history } from 'store';
import './index.css';

export default class BackButton extends PureComponent {
  static displayName = 'BackButton';
  render() {
    return (
      <button
        role="button"
        className="backButton chevron chevron--left chevron--invert"
        onClick={history.goBack}
      >
        <span className={'visible--desktop'}>Back</span>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/BackButton/index.js